import React, { createContext, useContext } from 'react';
import type { ChoreographerContextProviderProps } from './types.tsx';

const choreographedStatusContextValue = {
	isAlreadyChoreographedAtAncestor: true,
};

export const ChoreographerContextProvider = ({
	isChoreographed,
	children,
}: ChoreographerContextProviderProps): React.JSX.Element => {
	const { isAlreadyChoreographedAtAncestor } = useChoreographedStatusContext();

	const shouldUseChoreographerContextProvider =
		!isAlreadyChoreographedAtAncestor && isChoreographed;

	return shouldUseChoreographerContextProvider ? (
		<ChoreographedStatusContext.Provider value={choreographedStatusContextValue}>
			{children}
		</ChoreographedStatusContext.Provider>
	) : (
		<>{children}</>
	);
};

export const ChoreographedStatusContext: React.Context<{
	isAlreadyChoreographedAtAncestor: boolean;
}> = createContext<{
	isAlreadyChoreographedAtAncestor: boolean;
}>({
	isAlreadyChoreographedAtAncestor: false,
});

export const useChoreographedStatusContext = (): {
	isAlreadyChoreographedAtAncestor: boolean;
} => useContext(ChoreographedStatusContext);
